// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__Ot3Dz","subheader":"ReorderModal_subheader__2gsLC","listWrap":"ReorderModal_listWrap__3Bp4B"};